import { ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatStepperModule } from '@angular/material/stepper';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { DashboardService } from '../../../utilities/services/dashboard-service/dashboard.service';
import { CommonModule } from '@angular/common';
import { NgOtpInputModule } from 'ng-otp-input';
import { AuthServiceService } from '../../../utilities/services/auth-service/auth-service.service';
import { OverlayModule } from '@angular/cdk/overlay';
import { StepsModule } from 'primeng/steps';
import { CommonServiceService } from '../../../utilities/services/common-service/common-service.service';
import { StepperModule } from 'primeng/stepper';

import { environment } from '../../../../environments/environment';

import { ThemeServiceService } from '../../../utilities/services/theme-service.service';
import { Subject, takeUntil } from 'rxjs';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { EncryptDecryptService } from '../../../utilities/services/EncrptyDecrypt/encrypt-decrypt.service';

interface MenuItem {
  label: string;
  command?: (event?: any) => void;
  isEnabled?: boolean;
  isCompleted?: boolean;
  styleClass?: string;
}
@Component({
  selector: 'stupa-forgot-password',
  standalone: true,
  imports: [MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule, StepsModule,
    MatDividerModule, StepperModule,
    CommonModule, FormsModule, ReactiveFormsModule, NgOtpInputModule, OverlayModule, TranslateModule],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})

export class ForgotPasswordComponent implements OnInit, OnDestroy {
  is_dark: boolean = false;
  logo_dark: string = environment.logo_dark;
  logo_light: string = environment.logo_light;

  /** Light-theme logo; TTNZ uses `login_sidebar_logo_light` from env. */
  get loginSidebarLogoLight(): string {
    const env = environment as typeof environment & {
      login_sidebar_logo_light?: string;
    };
    if (env.tenant_Name === 'spain' || env.tenant_Name === 'ptta') {
      return env.logo;
    }
    return env.login_sidebar_logo_light ?? env.logo_dark;
  }

  //Declaring Variables
  items: MenuItem[] = [
    {
      label: 'Sent OTP',
      command: (event: any) => {
        this.activeIndex = 0;
      },
      isEnabled: true,
      isCompleted: false
    },
    {
      label: 'Verify OTP',
      command: (event: any) => {
        this.activeIndex = 1;
      },
      isEnabled: false,
      isCompleted: false
    },
    {
      label: 'Change Password',
      command: (event: any) => {
        this.activeIndex = 2;
      },
      isEnabled: false,
      isCompleted: false
    },
  ];

  activeIndex: number = 0;
  // sendotp: boolean = true;
  @ViewChild('ngOtpInput', { static: false }) ngOtpInput: any;
  config = {
    allowNumbersOnly: false,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      width: '17%',
      height: '40px',
    },
  };
  _currentOTP: any = '';
  // _userEmail: any = '';
  _startCountdown: boolean = false;
  // countdown: any;
  timer: any = '';
  readonly otpTimerDuration = 180;
  _isResendingOtp = false;
  _forgotForm!: FormGroup;
  _emailForm!: FormGroup;
  _isSubmit: boolean = false;
  // _currentTime: any;
  intervalId: number = 0;
  azureLoggerConversion: any = new Error();
  innerWidth: any
  @HostListener('window:resize', ['$event'])
  logoUrl: string = '';
  onResize() {
    if (globalThis.window !== undefined) {
      this.innerWidth = globalThis.window.innerWidth;
    }
  }
  stepControls: FormGroup[];
  fetched_role_id: any = 0;
  role_field_id: any = 0;
  pasword_type_list = [
    { title: "8 characters long" },
    { title: "Include both uppercase and lowercase letters" },
    { title: "One number" },
    { title: "One special character (e.g., !, @, #, $)'." },
  ]
  overlayOpen = false;
  overlayOpen1 = false;
  passwordFieldType: string = 'password';
  passwordFieldType1: string = 'password';
  _isSubmited: boolean = false
  private readonly destroy$ = new Subject<void>();

  private resolveTenantName(): string {
    if (environment.tenant_Name !== 'switz' && environment.tenant_Name !== 'test_switz') {
      return environment.tenant_Name;
    }
    return 'switz';
  }

  tenant_name: string = this.resolveTenantName();

  constructor(
    private readonly authService: AuthServiceService,
    private readonly formBuilder: FormBuilder,
    private readonly route: Router,
    private readonly _formBuilder: FormBuilder,
    private readonly dashboardService: DashboardService,
    private readonly cdr: ChangeDetectorRef,
    private readonly common: CommonServiceService,
    private readonly themeService: ThemeServiceService,
    private readonly encryptDecryptService: EncryptDecryptService,
    private readonly translateService: TranslateService
    // private readonly messageService: MessageService,
    // private readonly azureLoggerService : MyMonitoringService,
    // private readonly encyptDecryptService : EncyptDecryptService
  ) {
    this.stepControls = this.items.map(() => this._formBuilder.group({}));
    if (globalThis.window?.sessionStorage !== undefined) {
      this.fetched_role_id = sessionStorage.getItem('fetched_role_id')
      this.role_field_id = sessionStorage.getItem('role_field_id')
    }
    if (globalThis.window !== undefined) {
      this.innerWidth = globalThis.window.innerWidth;
    }

    this._forgotForm = this.formBuilder.group({
      email: new FormControl(
        '',
        [Validators.required, Validators.email]
      ),
      password: new FormControl('', Validators.compose([
        Validators.required,
        Validators.maxLength(70),
        Validators.pattern(
          /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])(?=.{8,})/
        ),
      ])),
      confirmPassword: new FormControl('', Validators.compose([
        Validators.required,
        Validators.maxLength(70),
        Validators.pattern(
          /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])(?=.{8,})/
        ),
      ])),
    });

    // Separate form for email step only
    this._emailForm = this.formBuilder.group({
      email: new FormControl(
        '',
        [Validators.required, Validators.email]
      )
    });
  }
  // email: new FormControl(
  //   '',
  //   Validators.compose([
  //     Validators.required,
  //     Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
  //   ])
  // ),
  showPassword(data: any) {
    const type = data.type === 'password' ? 'text' : 'password';
    const eye = document.querySelector('#eye');
    if (data.type === "text" || data.type === "password") {
      data.type = type;
      eye?.classList.toggle('pi-eye');
    }
  }

  checkIndex(data: any) {
    this.activeIndex = data.selectedIndex;
    this.items[this.activeIndex].command?.();
  }

  ngOnInit(): void {
    this.themeService.isDark$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isDark: boolean) => {
        this.is_dark = isDark;
        this.cdr.detectChanges();
      });

    // Initialize theme value
    this.is_dark = this.themeService.getTheme();

    // Add real-time validation for password match (cleaned up with takeUntil)
    this._forgotForm.get('password')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      // Trigger change detection when password changes
      this.cdr.detectChanges();
    });

    this._forgotForm.get('confirmPassword')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      // Trigger change detection when confirm password changes
      this.cdr.detectChanges();
    });
  }
  //For Getting Current OTP
  onOtpChange(otp: any) {
    this._currentOTP = otp;
  }
  ngOnDestroy() {
    clearInterval(this.intervalId);
    this.destroy$.next();
    this.destroy$.complete();
  }

  //With method is used for Send OTP
  sendOtp() {

    // Mark all form controls as touched to trigger validation display
    this._emailForm.markAllAsTouched();

    // Check if form is valid before proceeding
    if (this._emailForm.invalid) {
      return;
    }

    if (globalThis.window?.sessionStorage !== undefined) {
      sessionStorage.removeItem('tokenForChangePassword');
    }
    clearInterval(this.intervalId);
    this._isSubmit = true;
    this.timer = 180; // 3 minutes

    if (this._emailForm.controls['email'].value != null && this._emailForm.controls['email'].value != '') {
      this.authService
        .forgot_password(this._emailForm.controls['email'].value, this.fetched_role_id, this.role_field_id)
        .subscribe({
          next: (result: any) => {

            if (globalThis.window?.sessionStorage !== undefined) {
              sessionStorage.setItem(
                'tokenForChangePassword',
                'enc:' + this.encryptDecryptService.encryptUsingAES256(String(result.data?.token ?? ''))
              );
            }
            this.activeIndex = 1;
            // Mark first step as completed
            this.items[0].isCompleted = true;
            this.items[1].isEnabled = true;
            // Add styleClass for completed step
            this.items[0].styleClass = 'p-steps-item-completed';
            // Force update of steps array to trigger change detection
            this.items = [...this.items];
            this.cdr.detectChanges();
            this.dashboardService.toast(result.msg, 'success');
            if (this.timer > 0) {
              this.startOtpCountdown();
            }
          },
          error: (result: any) => {
            let errorMessage = result.error?.msg || this.translateService.instant('errorMessage');
            this.dashboardService.toast(errorMessage, 'error');
            this._isSubmit = false
          },
          complete: () => undefined,
        });
    }
  }

  verifyOTP() {

    this._isSubmit = true;
    const body =
    {
      "otp": {
        email: this._emailForm.controls['email'].value,
        code: this._currentOTP,
      }
    }


    this.authService.verifyOTP(body).subscribe({
      next: (result: any) => {

        if (globalThis.window?.sessionStorage !== undefined) {
          sessionStorage.setItem(
            'tokenForChangePassword',
            'enc:' + this.encryptDecryptService.encryptUsingAES256(String(result.data?.token ?? ''))
          );
        }
        this._forgotForm.controls['password'].updateValueAndValidity();
        this.activeIndex = 2;
        // Set the email value in _forgotForm from _emailForm
        this._forgotForm.controls['email'].setValue(this._emailForm.controls['email'].value);
        // Mark second step as completed
        this.items[1].isCompleted = true;
        this.items[2].isEnabled = true;
        // Add styleClass for completed step
        this.items[1].styleClass = 'p-steps-item-completed';
        // Force update of steps array to trigger change detection
        this.items = [...this.items];
        this.cdr.detectChanges();
        this.dashboardService.toast(result.msg, 'success');
      },
      error: (result: any) => {
        let errorMessage = result.error?.msg || this.translateService.instant('errorMessage');
        this.dashboardService.toast(errorMessage, 'error');
      },
      complete: () => undefined,
    });
  }
  //This method is used for change password
  changePassword() {
    this._forgotForm.controls['password'].setValidators(
      Validators.required
    );
    if (this.activeIndex === 2) {
      // Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*])(?=.{8,})/)]);
      // this._forgotForm.controls['password'].updateValueAndValidity();
    }
    this._isSubmited = true;

    // Check if all password criteria are met and passwords match
    if (this.isAllPasswordCriteriaMet() && this.isPasswordMatch()) {
      const body = {
        new_password: this._forgotForm.controls['password'].value,
        identifier: this._emailForm.controls['email'].value,
      };
      this.authService.password_reset(body).subscribe({
        next: (result: any) => {
          this.dashboardService.toast(result.msg, 'success');
          this.common.forgot_password_subject.next(false);
          this.common.login_subject.next(true);
        },
        error: (result: any) => {
          let errorMessage = result.error?.msg || this.translateService.instant('errorMessage');
          this.dashboardService.toast(errorMessage, 'error');
        },
        complete: () => console.info('complete'),
      });
    } else {
      this.dashboardService.toast(this.translateService.instant('password_criteria_not_met'), 'error');
    }
  }


  formatOtpTimer(): string {
    const totalSeconds = Number(this.timer) || 0;
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  getOtpTimerProgress(): number {
    const totalSeconds = Number(this.timer) || 0;
    return Math.max(0, Math.min(100, (totalSeconds / this.otpTimerDuration) * 100));
  }

  getMaskedEmail(): string {
    const email = this._emailForm?.controls['email']?.value?.trim?.() ?? '';
    if (!email || !email.includes('@')) {
      return '';
    }

    const [localPart, domain] = email.split('@');
    if (!localPart || !domain) {
      return '';
    }

    const visiblePrefix = localPart.slice(0, Math.min(3, localPart.length));
    return `${visiblePrefix}***@${domain}`;
  }

  isOtpCountdownActive(): boolean {
    return this._startCountdown && Number(this.timer) > 0 && !this._isResendingOtp;
  }

  isOtpExpired(): boolean {
    return this._startCountdown && Number(this.timer) <= 0;
  }

  private startOtpCountdown(): void {
    clearInterval(this.intervalId);
    this.timer = this.otpTimerDuration;
    this._startCountdown = true;

    if (typeof window !== 'undefined') {
      this.intervalId = window.setInterval(() => {
        if (this.timer > 0) {
          this.timer -= 1;
        }
      }, 1000);
    }
  }

  // Method to resend OTP
  resendOtp() {
    if (this._isResendingOtp) {
      return;
    }

    this._currentOTP = '';

    if (this.ngOtpInput) {
      this.ngOtpInput.setValue('');
    }

    this._isResendingOtp = true;
    this._isSubmit = true;

    const userEmail = this._emailForm.controls['email'].value;

    if (userEmail != null && userEmail != '') {
      this.authService
        .forgot_password(userEmail, this.fetched_role_id, this.role_field_id)
        .subscribe({
          next: (result: any) => {
            if (globalThis.window?.sessionStorage !== undefined) {
              sessionStorage.setItem(
                'tokenForChangePassword',
                'enc:' + this.encryptDecryptService.encryptUsingAES256(String(result.data?.token ?? ''))
              );
            }

            this._isResendingOtp = false;
            this.startOtpCountdown();

            // `||` is intentional: an empty msg should also fall back to the default.
            const successMessage = result.msg || this.translateService.instant('otp_resent_successfully');
            this.dashboardService.toast(successMessage, 'success');
          },
          error: (result: any) => {
            this._isResendingOtp = false;
            let errorMessage = result.error?.msg || this.translateService.instant('errorMessage');
            this.dashboardService.toast(errorMessage, 'error');
            this._isSubmit = false;
          },
          complete: () => {
            this._isSubmit = false;
          },
        });
    } else {
      this._isResendingOtp = false;
      this._isSubmit = false;

      this.dashboardService.toast(this.translateService.instant('please_enter_email_first'), 'error');
    }
  }
  // onSubmit(): void {

  // }

  isEditable(index: number) {
    return this.items[index].isEnabled;
  }
  togglePasswordVisibility() {
    this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
  }
  togglePasswordVisibility1() {
    this.passwordFieldType1 = this.passwordFieldType1 === 'password' ? 'text' : 'password';
  }

  // Password validation methods
  isPasswordLengthValid(): boolean {
    const password = this._forgotForm.get('password')?.value;
    return password && password.length >= 8;
  }

  isPasswordUppercaseValid(): boolean {
    const password = this._forgotForm.get('password')?.value;
    return password && /[A-Z]/.test(password);
  }

  isPasswordNumberValid(): boolean {
    const password = this._forgotForm.get('password')?.value;
    return password && /\d/.test(password);
  }

  isPasswordSpecialValid(): boolean {
    const password = this._forgotForm.get('password')?.value;
    return password && /[!@#$%^&*]/.test(password);
  }

  isPasswordMatch(): boolean {
    const password = this._forgotForm.get('password')?.value;
    const confirmPassword = this._forgotForm.get('confirmPassword')?.value;
    return password && confirmPassword && password === confirmPassword;
  }

  // Check if all password criteria are met
  isAllPasswordCriteriaMet(): boolean {
    return this.isPasswordLengthValid() &&
      this.isPasswordUppercaseValid() &&
      this.isPasswordNumberValid() &&
      this.isPasswordSpecialValid();
  }

  closeDialog() {
    this.common.forgot_password_subject.next(false);
    this.common.login_subject.next(false);
    if (typeof window !== 'undefined') {
      sessionStorage.removeItem('redirectAfterLogin');
      sessionStorage.removeItem('redirectSource');
    }
  }

  back_to_login() {
    this.common.forgot_password_subject.next(false);
    this.common.login_subject.next(true);
  }
}

